import React from "react";
import "./css/mycss.css";

const Modal = ({ show, onClose, title, content }) => {
  if (!show) return null;

  const handleOverlayClick = () => {
    onClose();
  };

  const handleBoxClick = (event) => {
    event.stopPropagation();
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-box" onClick={handleBoxClick}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2>{title}</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div
          className="modal-content"
          style={{
            textAlign: "left",
            margin: "15px 0",
            lineHeight: "1.6"
          }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

export default Modal;
